import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFetchEapSetting } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/service/hooks/use-fetch-eap-setting.hook';
import { initialEapSettingsCreateFormModel } from '../use-eap-settings-data-handler/use-eap-settings-data-handler.constants';
import { useEapSettingsDataHandler } from '../use-eap-settings-data-handler/use-eap-settings-data-handler.hook';
import { useEapSettingSaver } from '../use-eap-settings-save/use-eap-settings-saver.hook';

export const useEapSettingsForm = (eapSettingId?: string) => {
    const navigate = useNavigate();

    const isEditMode = eapSettingId !== undefined && eapSettingId !== 'new';

    const { eapSetting, isLoading: isFetchLoading } = useFetchEapSetting(isEditMode ? eapSettingId : '');

    const initialData = useMemo(
        () =>
            isEditMode && eapSetting?.id
                ? { ...initialEapSettingsCreateFormModel, ...eapSetting }
                : { ...initialEapSettingsCreateFormModel },
        [isEditMode, eapSetting]
    );

    const {
        isLoading: isMutationLoading,
        errors,
        saveEapSetting,
    } = useEapSettingSaver({ isEditMode: isEditMode && !!eapSetting?.id });

    const handleOnClose = useCallback(() => {
        const currentPath = location.pathname;
        const pathSegments = currentPath.split('/');
        const newPath = pathSegments.slice(0, -1).join('/');
        navigate(newPath);
    }, [navigate]);

    const { eapSettings, handleDataChange, unsavedData, isDataValid } = useEapSettingsDataHandler({
        onClose: handleOnClose,
        initialData,
        isEditMode: isEditMode && !!eapSetting?.id,
    });

    const handleSave = () => {
        saveEapSetting(eapSettings).then(() => {
            unsavedData.setIsUnsavedChanges(false);
        });
    };

    return {
        eapSettings,
        isEditMode,
        isLoading: isMutationLoading || isFetchLoading,
        isFetchLoading,
        errors,
        assignedDeviceCount: isEditMode ? (eapSetting?.assignedDeviceCount ?? 0) : 0,
        handleDataChange,
        handleSave,
        unsavedData,
        isDataValid,
    };
};
